import Swiper from 'swiper';
import $ from 'jquery';

function sliders() {
    var logotypesSwiper = new Swiper('.logotypes-section__swiper', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        // If we need pagination
        pagination: false,

        // Navigation arrows
        navigation: false,

        // And if we need scrollbar
        scrollbar: false,

        autoplay: true,

        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            400: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 6,
                spaceBetween: 20
            },
            1300: {
                slidesPerView: 8,
                spaceBetween: 20
            }
        }
    });

    var timelineSwiper = new Swiper('.timeline-section__swiper', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: "auto",
        // If we need pagination
        pagination: false,

        // Navigation arrows
        navigation: {
            nextEl: ".timeline-section__arrow--next",
            prevEl: ".timeline-section__arrow--prev"
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.timeline-section__scrollbar',
            draggable: true,
        },

        autoplay: false,
        slidesPerGroup: 1,

        breakpoints: {
            1023: {
                slidesPerGroup: 2,
            },
        }
    });
    if (timelineSwiper.length > 0) {
        window.addEventListener("orientationchange", function () {
            let index = timelineSwiper.activeIndex;

            if ($('.timeline-section__swiper').length > 0) {
                timelineSwiper.slideTo(0);
            }
        }, false)
    }
}

function timelineSlider() {
    initTimelineSlider();

    $(window).resize(function () {
        initTimelineSlider();
    });
}

function initTimelineSlider() {
    let width = window.innerWidth,
        multirow = width > 1023;

    calculateTimelineSliderItemHeight(multirow);
}

function calculateTimelineSliderItemHeight(multirow) {
    let swiper = $('.timeline-section__swiper'),
        maxHeight = 0;

    swiper.find('.timeline-item__inner').each(function () {
        $(this).height('');
    });

    swiper.find('.timeline-item__inner').each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    swiper.find('.timeline-item__inner').each(function () {
        if (multirow) {
            $(this).height(maxHeight * 2)
        } else {
            $(this).height('');
        }
    });
}

export {sliders, timelineSlider}